//imports
import { all } from 'redux-saga/effects';

//Views
import createEditSmsSystemSagas from 'Modules/smsSystems/views/.components/createEditSmsSystem/redux/saga';
import deleteSmsSystemSagas from 'Modules/smsSystems/views/.components/deleteSmsSystem/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        createEditSmsSystemSagas(),
        deleteSmsSystemSagas(),
    ]);
}